/**
 * Jedno źródło prawdy o dostawie — te same wartości co na /dostawa-i-zwroty
 * i w faktach asystenta (src/lib/assistant/knowledge.ts). Używane w koszyku,
 * checkoucie, API zamówienia i JSON-LD produktu. Zmieniasz tutaj = wszędzie.
 * Zgodne z commerce order-pricing: 300 / 15 locker / 18 courier / 20 COD.
 */
export const FREE_SHIPPING_THRESHOLD = 300
export const COD_SURCHARGE = 20

export type ShippingMethod = 'kurier' | 'paczkomat'

export const SHIPPING_METHODS: Record<ShippingMethod, { label: string; description: string; price: number }> = {
  kurier: { label: 'Kurier InPost', description: 'Dostawa do drzwi, 1–2 dni robocze', price: 18 },
  paczkomat: { label: 'Paczkomat InPost', description: 'Odbiór 24/7, 1–2 dni robocze', price: 15 },
}

export function formatShippingPln(amount: number): string {
  return `${String(amount).replace('.', ',')} zł`
}

/** Najtańsza opcja dostawy — np. do JSON-LD (Google wymaga jednej stawki). */
export const CHEAPEST_SHIPPING = Math.min(...Object.values(SHIPPING_METHODS).map((m) => m.price))

export function isShippingMethod(v: unknown): v is ShippingMethod {
  return v === 'kurier' || v === 'paczkomat'
}

/** Koszt dostawy dla danej metody i wartości koszyka (0 przy darmowym progu). */
export function shippingCost(method: ShippingMethod, subtotal: number): number {
  return subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_METHODS[method].price
}
